import React from "react";
import StandingTable from "./Standings";
const InfoTable = ({ tableData }) => {
  const data = tableData?.football_tournament_tables;
  const renderLeagueTable = (data) => {
    if (!data || data.length === 0) {
      return <p>No standings found</p>;
    }

    return <StandingTable data={data?.slice(0, 3)} Groupdata={true} />;
  };

  return (
    <>
      {data?.length > 0 && (
        <div>
          <h2>Standings</h2>
          {renderLeagueTable(data)}
        </div>
      )}
    </>
  );
};

export default InfoTable;
